import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const TableContainer = styled.div`
  padding: 24px 14px 24px 24px;
  background: ${colors.background};
`
